module.exports = __webpack_public_path__ + "static/media/persona_fisica.a74fc27e.svg";